export const clientLevelPage = {
  message: 'OK',
  data: [
    {
      id: '1',
      label: 'Nivel 1 - Base'
    },
    {
      id: '2',
      label: 'Nivel 2 - Confianza'
    },
    {
      id: '3',
      label: 'Nivel 3 - Preferente'
    },
    {
      id: '4',
      label: 'Nivel 4 - \u00c9lite'
    }
  ],
  status: 200
}

export const levelsData = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        name: 'Bronce',
        minPoints: 0,
        maxPoints: 999,
        lineMultiplier: 1.0,
        maxSimultaneousRecharges: 1,
        activeDevices: 1,
        activeMotorcycles: 0,
        rechargeDiscount: 0.0,
        initial: 100.0,
        isActive: true,
        rentability: 1
      },
      {
        id: '2',
        name: 'Oro',
        minPoints: 1000,
        maxPoints: 2999,
        lineMultiplier: 1.5,
        maxSimultaneousRecharges: 3,
        activeDevices: 3,
        activeMotorcycles: 1,
        rechargeDiscount: 5.0,
        initial: 200.0,
        isActive: true,
        rentability: 1
      },
      {
        id: '3',
        name: 'Platino',
        minPoints: 3000,
        maxPoints: 9999,
        lineMultiplier: 2.0,
        maxSimultaneousRecharges: 5,
        activeDevices: 5,
        activeMotorcycles: 2,
        rechargeDiscount: 10.0,
        initial: 300.0,
        isActive: true,
        rentability: 1
      },
      {
        id: '4',
        name: 'Diamante',
        minPoints: 10000,
        maxPoints: 99999,
        lineMultiplier: 3.0,
        maxSimultaneousRecharges: 10,
        activeDevices: 10,
        activeMotorcycles: 3,
        rechargeDiscount: 15.0,
        initial: 500.0,
        isActive: false,
        rentability: 1
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}
